import { createClient } from '@supabase/supabase-js';

// Prefer environment; fallback to shared project credentials if provided
const envUrl = process.env.REACT_APP_SUPABASE_URL;
const envAnon = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Shared project (reference) fallback
const fallbackUrl = 'https://dznggoutqhvcofyrduqp.supabase.co';
const fallbackAnon = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR6bmdnb3V0cWh2Y29meXJkdXFwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQwNTI0MTMsImV4cCI6MjA3OTYyODQxM30.bNaYOhuNdnBM5-63ejLUzPsb16WiXlM6Y4LCOKixkg4';

const supabaseUrl = envUrl || fallbackUrl;
const supabaseAnonKey = envAnon || fallbackAnon;

export const isSupabaseConfigured = Boolean(supabaseUrl) && Boolean(supabaseAnonKey);

export const supabase = isSupabaseConfigured
	? createClient(supabaseUrl, supabaseAnonKey, {
		auth: {
			persistSession: false
		}
	})
	: null;
